import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import PanelSubHeading from "../../components/panel/subHeading";
import PanelHeading from "../../components/panel/heading";
import PanelSearch from "../../components/filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import { closeModal, openModal } from "../../state/modalSlice";
import ClientListTable from "../../components/activity/clientListTable";
import CustomerCreationModal from "../../modals/customer/createCustomer";
import { backend } from "../../services/backend";
import { toast } from "sonner";
import { CustomerListFilters, defaultCustomerFilters } from "../../forms/filters/customers";
import CustomerFilterModal from "../../modals/filters/client";
import ClientsListWidget from "../../components/widgets/clientListWidget";

const ClientsListPage = () => {

  const [searchValue, setSearchValue] = useState("")
  const [update, triggerUpdate] = useState(true);
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const filters = State.customerFilters;

    const search = (value: string) => {
      console.log(value)
      setSearchValue(value);
      dispatch(actions.customerRequestParams({...filters, search_query: value}))
    }
  
    useEffect(() => {      
        backend.getAllCustomers(filters).then((res) => {
        dispatch(actions.customerListData(res.customers));
      }).catch((e) => {
        console.log(e.error || e);
        toast("Не удалось загрузить список клиентов")
      })
    }, [filters])

  const handleOpenModal = () => {
    console.log("Called")
    dispatch(openModal({ component: CustomerCreationModal, context: {
      onSave: (file: File) => {
        console.log('Сохранено:', file.name);
        triggerUpdate(state => !state)
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  };

  const handleOpenFilters = () => {
    dispatch(
      openModal({
        component: CustomerFilterModal,
        context: {
          onApplyFilters: (filters: CustomerListFilters) => {
  
            dispatch(actions.customerRequestParams({ ...structuredClone(filters) }));
  
            console.log("Filters applied:", filters);
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <ClientsListWidget />
      </div>
    </PanelPage>
  );
};

export default ClientsListPage;
